import { createTheme } from '@mui/material/styles';

// Global styles that override material-ui defaults.
// See: https://mui.com/material-ui/customization/theme-components/
export const intusTheme = createTheme({});
